import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  Grid,
  Image,
  Header,
  Modal
} from 'semantic-ui-react';

import Booking from '../components/Booking';

import {
  closeParkingLotPopup,
} from '../actions/bookPayConfirmActions';

import defaultPicture from '../images/parkingLotPopup/default.svg';
import prDefaultPicture from '../images/parkingLotPopup/prDefault.svg';
import parkingIcon from '../images/parkingLotPopup/parkingIcon.svg';
import prIcon from '../images/parkingLotPopup/prIcon.svg';

class ParkingLotPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      booking: false,
    }
  }

  getDefaultPicture = () => {
    const name = this.props.parkingLotNames[this.props.index].toString();

    if (name.includes('P+R')) {
      return prDefaultPicture;
    } else {
      return defaultPicture;
    }
  }


  getIcon = () => {
    const name = this.props.parkingLotNames[this.props.index].toString();

    if (name.includes('P+R')) {
      return prIcon;
    } else {
      return parkingIcon;
    }
  }

  closePopup = () => {
    this.setState({
      booking: true,
    });
  }

  render() {
    return (
      <Modal
        closeIcon
        open={this.props.parkingLotPopupVisible && this.props.visible && this.state.booking===false}
        onClose={() => { this.props.closeParkingLotPopup() }}
      >
        <Modal.Content image>
          {/* <Image src={this.getDefaultPicture()} */}
          <Modal.Description>
            <Header>
              <Grid>
                <Grid.Row style={{ paddingBottom: 0 }}>
                  <Grid.Column width='1' >
                    <Image width='50px' src={this.getIcon()} floated='left' />
                  </Grid.Column>
                  <Grid.Column width='13'>
                    {this.props.name}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{ paddingTop: 0 }}>
                  <Grid.Column width='1'>

                  </Grid.Column>
                  <Grid.Column width='13' style={{ fontWeight: 'normal' }}>
                    {this.props.parkingLotAddresses[this.props.index]}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Header>
          </Modal.Description>
        </Modal.Content>
        {/* <Modal.Actions>
          {
            this.props.parkingPrices[this.props.index] !== '0 €' &&
            this.props.parkingPrices[this.props.index] !== '' &&
            <Booking visible={this.props.selectedRoute === this.props.index} index={this.props.index} />
          }
        </Modal.Actions> */}
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  parkingLotNames: state.posts.parkingLotNames,
  parkingLotAddresses: state.posts.parkingLotAddresses,
  parkingPrices: state.posts.parkingPrices,
  parkingLotPopupVisible: state.screens.parkingLotPopupVisible,
  selectedRoute: state.posts.selectedRoute,
  screensVisible: state.screens.screensVisible,
});

export default connect(mapStateToProps, { closeParkingLotPopup })(ParkingLotPopup)